module.exports = __webpack_public_path__ + "media/images/logo@2x-ed840c78effe7e15d0e094c92a0f852a.png";